import ErrorHandler from '@schachermayer/sch-vuejs-commons/src/errors';
import { Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import { UserInfoApi } from '../../../build/swagger-code-extranet-api-definition/apis/user-info-api';
import { UserInfo } from '../../../build/swagger-code-extranet-api-definition/models';

const userInfoApi: UserInfoApi = new UserInfoApi({ basePath: process.env.VUE_APP_CONTEXT_BASE });

@Module({
    namespaced: true,
    name: 'userInfo',
})
export default class UserInfoStoreModule extends VuexModule {

    userInfo: UserInfo = {};
    isLoading: boolean = true;

    @MutationAction({ mutate: ['userInfo', 'isLoading'], rawError: true })
    async loadUserInfo() {
        try {
            const userInfo: UserInfo = (await userInfoApi.getUserInfo({ credentials: 'same-origin' })).data;

            return { userInfo, isLoading: false };
        } catch (error) {
            if (error.status !== 401) {
                ErrorHandler.handleError(error);
            }
            const currentUserInfo = (this.state as UserInfoStoreModule).userInfo;
            return { userInfo: currentUserInfo, isLoading: false };
        }
    }

    @Mutation
    setUserCatalogIdentifier(catalogIdentifier: string) {
        this.userInfo.catalogIdentifier = catalogIdentifier;
    }

}
